import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';

interface IPagePr0035 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Pr0035Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPagePr0035 = this;

    vm.multiOccurrenceOptions = {
        colonnesVisibles: [
            { nom: 'prwcod', largeur: 65 },
            { nom: 'prwdsc', largeur: 230 },
            { nom: 'prwflgstu', largeur: 74 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('prwcod', { required: true, largeur: 25 }),
            new FormulaireItem('prwdsc', { largeur: 50 }),
            new FormulaireItem('prwflgstu', { largeur: 25, default: 1 })
        ]),
        fonctions: {
            rechercheCollapsable: false
        },
    };
}
